import request from '@/utils/request'

// 查询二手车评估分页
export function pageCarMent(query) {
  return request({
    url: '/carMent/carMent/page',
    method: 'get',
    params: query
  })
}

// 查询二手车评估列表
export function listCarMent(query) {
  return request({
    url: '/carMent/carMent/list',
    method: 'get',
    params: query
  })
}

// 删除二手车评估
export function delCarMent(data) {
  return request({
    url: '/carMent/carMent/delete',
    method: 'post',
    data: data
  })
}
